import Icon from '@/root/ui/shared/Icon'
import { IconProps } from '@/root/shared-types/ui/ui-types'
import { FC } from 'react'

export const ChevronDownIconWhite: FC<IconProps> = ({ width = 40, height = 36, ...rest }) => (
  <Icon type="ChevronDownWhite" width={width} height={height} alt="ChevronDownIconWhite" {...rest} />
)
